import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import zh from './zh'
import en from './en'

export type AppLang = 'zh' | 'en'
export const LANG_KEY = 'pagedrop:lang'

/** 首次语言探测：?lang= 参数（可分享、可被搜索引擎的 hreflang 变体命中）> 本地记忆 > 浏览器语言 */
function detectInitialLang(): AppLang {
  const fromUrl = new URLSearchParams(window.location.search).get('lang')
  if (fromUrl === 'zh' || fromUrl === 'en') {
    localStorage.setItem(LANG_KEY, fromUrl)
    return fromUrl
  }
  const saved = localStorage.getItem(LANG_KEY)
  if (saved === 'zh' || saved === 'en') return saved
  return navigator.language.toLowerCase().startsWith('zh') ? 'zh' : 'en'
}

const initial = detectInitialLang()
document.documentElement.lang = initial === 'zh' ? 'zh-CN' : 'en'

void i18n.use(initReactI18next).init({
  resources: {
    zh: { translation: zh },
    en: { translation: en },
  },
  lng: initial,
  fallbackLng: 'zh',
  interpolation: { escapeValue: false },
})

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng === 'zh' ? 'zh-CN' : 'en'
  localStorage.setItem(LANG_KEY, lng)
})

export default i18n
